import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import RestaurantSharpIcon from "@mui/icons-material/RestaurantSharp";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function NavigationBar() {
  const navItems = [
    { text: "Home", path: "/" },
    { text: "Recipes ", path: "/recipes" },
    { text: "Blogs", path: "/blog" },
    { text: "Products", path: "/all-products" },
    { text: "Videos", path: "/all-videos" },
    { text: "About Us", path: "/aboutUs" },
    { text: "Contact", path: "/contact" },
  ];

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{
          background: "linear-gradient(90deg, #b71c1c, #f44336)",
        }}
      >
        <Toolbar>
          <RestaurantSharpIcon color="white" />
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, color: "#fff", fontWeight: "bold" }}
          >
            Sonika The Chef
          </Typography>

          {/* Mobile Menu Button */}
          <IconButton
            edge="start"
            color="success"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ display: { xs: "block", sm: "none" }, color: "#fff" }}
          >
            <MenuIcon />
          </IconButton>

          {/* Comment Desktop Menu Button   */}
          {navItems.map((item) => (
            <Button
              key={item.text}
              component={Link}
              to={item.path}
              sx={{
                display: { xs: "none", sm: "inline-flex" },
                color: "#fff",
                fontWeight: "500",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              {item.text}
            </Button>
          ))}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { xs: "block", sm: "none" } }}
      >
        <List sx={{ width: 250 }}>
          {navItems.map((item) => (
            <ListItem
              button
              color="success"
              key={item.text}
              component={Link}
              to={item.path}
              onClick={handleDrawerToggle}
              sx={{
                "&:hover": {
                  backgroundColor: "#f8bbd0",
                },
              }}
            >
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
